const languagServiceName = "/ResumeLanguage"

export function languageService(http) {
    return {
        getAllLanguages(){
            return http.get(languagServiceName + "/GetAllLanguages");
        },
        getAllLanguagesProficiency(){
            return http.get(languagServiceName + "/GetAllLanguagesProficiency");
        }
    }
}